export enum Timezone {
  //

  //

  //

  //

  EuropeAmsterdam = 'Europe/Amsterdam',
  EuropeBerlin = 'Europe/Berlin',
  EuropeLondon = 'Europe/London',
  EuropeMadrid = 'Europe/Madrid',
  EuropeParis = 'Europe/Paris',
  EuropeRome = 'Europe/Rome',
  EuropeStockholm = 'Europe/Stockholm',
  EuropeHelsinki = 'Europe/Helsinki',
  EuropeAthens = 'Europe/Athens',
  EuropeIstanbul = 'Europe/Istanbul',
  EuropeMinsk = 'Europe/Minsk',

}
